import { getLanguageCode, getCountryCode } from 'utilities/locales';
import CartClient from 'clients/cart';
import { updateCartCount } from 'utilities/nav';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.AllProducts.init());

Sq.Shop.AllProducts = {
  utils: Sq.Shop.Utils,

  init() {
    if ($('#all-products-page').length === 0) {
      return;
    }

    this.disableTabHashTrigger();

    this.getHtml();
    this.bindEvents();
    this.onPageView();

    this.cartClient = new CartClient(
      this.utils.cartNumber(),
      getCountryCode(),
      getLanguageCode()
    );
  },

  // Sq.Tabs triggers on each hashchange in v4, which throws errors on this page
  disableTabHashTrigger() {
    Sq.Tabs.setTab = function () {};
  },

  getHtml() {
    this.$page = $('#all-products-page');
    this.$lineItems = $('.line-item');
    this.$quantityDropdowns = $('.line-item-quantity');
  },

  bindEvents() {
    // Listen for quantity changes to update the CTA language
    $(document).on('change', this.utils.QUANTITY_SELECTOR, (e) =>
      this.onQuantityChange(e)
    );
  },

  // ------------------------------------------------------------
  // Event handlers

  onPageView() {
    // Track
    this.utils.trackProductList(this.$page, {
      listName: 'All Products',
      impression: true,
    });
  },

  onQuantityChange(e) {
    const variantToken = e.currentTarget.id.split('-')[3].toString();
    const quantity = Number.parseInt(e.currentTarget.value, 10);
    const productName = this.utils.productData(e.currentTarget).name;

    this.cartClient
      .updateQuantity(variantToken, quantity, [], 'overwrite')
      .then((res) => {
        const resJson = res.json();
        if (res.status !== 200) {
          throw new Error(resJson.message);
        }

        return resJson;
      })
      .then((res) => {
        updateCartCount(res.item_count);
        this.utils.flashBanner().update({
          // todo(dhuxley): Translation
          // Untranslated copy since this is an internal-only page
          message: `'${productName}' added to cart`,
          state: 'success',
          timeout: 5000,
        });
      })
      .catch(() => {
        this.utils.flashBanner().update({
          // Untranslated copy since this is an internal-only page
          message: `Could not add '${productName}' to cart`,
          state: 'error',
          timeout: 5000,
        });
      });
  },
};
